export default "__VITE_ASSET__31phC1jg__"